const ROUTE_PATH = {
  LOGIN: "/login",
  ABOUT: "/about",
  HOW_IT_WORKS: "/how-it-works",
  DASHBOARD: "#",
  SIGNUP: `/signup`,
  HOME: `/`,
  BROWSE: `/browse`,
  MY_PROFILE: "#",
  INFO: "/info",
  TERMS_AND_CONDITION: "/terms-and-condition",
  PRIVACY_POLICY: "/privacy-policy",
  COLLECTION: "/collections/:collection/:id",
  PROFILE: "/profile",
  BAG:"/bag",
  CHECKOUT:"/checkout",
  PRODUCT_LIST: "/products",
  PRODUCT_DETAIL: "/product/:product/:id",
  DESIGNER_PRODCUTS_LIST: "/designer/:designer/:id",
  PAYMENT_SUCCESS: "/checkout-successful",
  PAYMENT_FAILURE: "/checkout-failed",
  CLOSET : "/closet",
  KEEP_ITEMS_PAYMENT_SUCCESS: "/keep-items-payment-success",
  ORDER_HISTORY: "/order-history",
  ORDER_HISTORY_DETAILS: "/order-history-deatils",
  USER_PROFILE: "/my-profile",
  EDIT_PROFILE: "/edit-profile",
  SETTINGS: "/settings",
  CUSTOMER_SUPPORT: "/customer-support",
  FORGET_PASSWORD: "/forget-password",
  FORGET_PASSWORD_CHECK_INBOX: "/forget-password-check-inbox",
  RESET_PASSWORD: "/reset-password/:uid/:token",
  RESET_LINK_EXPIRED: "/reset-link-expired"
};

const API_PATH = {};

export { ROUTE_PATH, API_PATH };
